<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
        this.$router.push("/purchase-edit/" + this.params.data.id).catch(() => {})
    },
    ViewRecord () {
        this.$router.push("/purchase/" + this.params.data.id).catch(() => {})
    }
  }
}
</script>
